<template>
    <div :class="'wrapper '+section">
        <!-- Sidebar -->
        <b-sidebar id="sidebar-moregiros" backdrop-variant="dark" no-header backdrop shadow v-if="user.role === 'Supervisor' || user.role === 'Partner'">
            <template #default="{ hide }">
                <div class="py-3">
                    <b-card body-class="py-0" bg-variant="transparent">
                        <b-row>
                            <b-col cols="5">
                                <figure class="avatar avatar-60 bci no-shadow">
                                    <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                                         :alt="user.name + ' ' + user.lname" :title="user.name + ' ' + user.lname">
                                </figure>
                            </b-col>
                            <b-col cols="7" align-self="center">
                                <b-button size="sm" variant="light" class="btn-rounded float-right text-default" to="/partner/account/information">
                                    <i class="material-icons mdi mdi-circle-edit-outline"></i>
                                </b-button>
                                <b-button size="sm" variant="light" class="btn-rounded float-right text-default mr-1" to="/partner/account/security">
                                    <i class="material-icons mdi mdi-lock"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="pt-1">
                                <h5 class="mb-1 line-hide">{{ (user.name + ' ' + user.lname).replace(',', '') }}</h5>
                                <p class="text-mute small mb-0">Categoría: {{ user.role === 'Supervisor' ? 'Supervisor' : 'Gerente ' + (user.partner && !user.branch ? 'Master' : 'Junior') }}</p>
                                <p class="text-mute small">IP: {{ user.ip }}</p>
                            </b-col>
                        </b-row>
                    </b-card>
                    <hr>
                    <nav class="mb-3">
                        <b-nav vertical>
                            <template v-for="(item, index) in admin">
                                <template v-if="item.children">
                                    <b-nav-item v-b-toggle="'open-'+index">
                                        <i :class="'material-icons mdi mdi-'+item.icon"></i>
                                        <span>{{ item.text }}</span>
                                        <i class="material-icons when-open float-right">arrow_drop_up</i>
                                        <i class="material-icons when-closed float-right">arrow_drop_down</i>
                                    </b-nav-item>
                                    <b-collapse :id="'open-'+index">
                                        <b-card body-class="p-0" bg-variant="transparent">
                                            <template v-for="subitem in item.children">
                                                <b-nav-item class="pl-3" active-class="children" exact-active-class="nav-exact" :to="'/'+(user.role === 'Partner' ? 'partner' : 'admin')+'/'+item.link+'/'+subitem.link">
                                                    <i :class="'material-icons mdi mdi-'+subitem.icon"></i>
                                                    <span>{{ subitem.text }}</span>
                                                </b-nav-item>
                                            </template>
                                        </b-card>
                                    </b-collapse>
                                </template>
                                <b-nav-item exact-active-class="nav-exact" :to="'/partner/'+item.link" v-else>
                                    <i :class="'material-icons mdi mdi-'+item.icon"></i>
                                    <span>{{ item.text }}</span>
                                </b-nav-item>
                            </template>
                            <b-nav-item exact-active-class="nav-exact" @click="logout">
                                <i class="material-icons mdi mdi-close-circle"></i>
                                <span>Cerrar Sesión</span>
                            </b-nav-item>
                        </b-nav>
                    </nav>
                </div>
            </template>
        </b-sidebar>
        <!-- Sidebar ends -->
        <!-- header -->
        <div class="header shadow">
            <b-row no-gutters>
                <b-col cols="auto">
                    <b-button variant="link" to="/partner/notifications" class="text-dark position-relative" v-if="user.role === 'Cashier'">
                        <i class="material-icons">notifications_none</i>
                        <span class="counts">{{ count < 10 ? count : '+9' }}</span>
                    </b-button>
                    <b-button variant="link" class="text-dark" v-else v-b-toggle.sidebar-moregiros>
                        <i class="material-icons">menu</i>
                    </b-button>
                </b-col>
                <b-col class="text-center">
                    <img :src="logo" alt="logo-moregiros" class="header-logo py-0">
                </b-col>
                <b-col cols="auto">
                    <b-button variant="link" to="/partner/account/settings" :class="user.partner ? 'text-success' : 'text-danger'" v-if="user.role === 'Cashier'">
                        <i class="material-icons">store</i>
                    </b-button>
                    <b-button variant="link" :class="user.partner ? 'text-success' : 'text-danger'" @click="form.partner = user.partner" v-b-modal.partner v-else-if="user.role === 'Supervisor'">
                        <i class="material-icons">store</i>
                    </b-button>
                    <b-button variant="link" to="/partner/account/rate" v-else>
                        <i class="material-icons">currency_exchange</i>
                    </b-button>

                    <!-- Modal Update Office Partner -->
                    <b-modal
                        v-if="user.role === 'Supervisor'"
                        id="partner"
                        centered
                        no-fade
                        header-class="text-center"
                        header-bg-variant="primary"
                        header-text-variant="light"
                        header-close-variant="light"
                        footer-class="border-0"
                        hide-footer
                        body-class="text-center px-4 my-4"
                        title="Selección de agente"
                        tabindex="-1"
                        role="dialog"
                        size="lg"
                        aria-hidden="true">
                        <b-form id="formPartner" @submit.stop.prevent="updatePartner(user.id)">
                            <b-row class="justify-content-center">
                                <b-col cols="12" md="9" align-self="start">
                                    <b-form-group :label="labels.partner+':'">
                                        <b-form-select
                                            name="partner"
                                            :options="user.partners"
                                            :value="form.partner"
                                            v-model="form.partner"
                                            class="form-control select-center"
                                            v-validate="'required:true'"
                                            :state="validateState('partner')"
                                            :data-vv-as="(labels.partner).toLowerCase()"
                                            :disabled="loading"
                                            aria-describedby="partner-live-feedback"
                                            value-field="code"
                                            text-field="name"
                                        ></b-form-select>
                                        <b-form-invalid-feedback id="partner-live-feedback">{{
                                                veeErrors.first('partner')
                                            }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="10" align-self="start" class="my-4">
                                    <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5" form="formPartner" :disabled="loading">
                                        <b-spinner small type="grow" v-if="loading"></b-spinner>
                                        <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                        &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-modal>
                </b-col>
            </b-row>
        </div>
        <!-- header ends -->

        <transition name="fade" mode="out-in">
            <router-view
                :user="user"
                @success="update"
                @loader="hideLoader"
                @section="getSection">
            </router-view>
        </transition>

        <!-- footer-->
        <footer class="footer" v-if="user.role === 'Cashier'">
            <b-row no-gutters>
                <b-col cols="auto" class="mx-auto">
                    <b-row no-gutters align-h="center">
                        <template v-for="item in navs">
                            <b-col cols="auto" v-if="!item.requiresWorkSchedule || workScheduleAllowed">
                                <b-button variant="link-default" :to="'/partner' + item.link">
                                    <i :class="'material-icons mdi mdi-' + item.icon"></i>
                                    <p>{{ item.name }}</p>
                                </b-button>
                            </b-col>
                        </template>
                    </b-row>
                </b-col>
            </b-row>
        </footer>
        <!-- footer ends-->
    </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';
import {CurrencyInput} from "vue-currency-input";

export default {
    name: "CustomerComponent",
    components: { CurrencyInput },
    data: () => ({
        loading: false,
        logo: '/img/logo_header.png',
        section: '',
        back: false,
        count: 0,
        user: {
            id: null,
            partner: null,
            name: null,
            lname: null,
            phone: null,
            email: null,
            country: null,
            role: 'partner',
            status: null
        },
        navs: [
            {
                link: '/home',
                icon: 'home-circle',
                name: 'Inicio'
            },{
                link: '/calculator',
                icon: 'calculator',
                name: 'Cotizar'
            },{
                link: '/request',
                icon: 'send-circle',
                name: 'Enviar',
                requiresWorkSchedule: true
            },{
                link: '/collect',
                icon: 'cash-register',
                name: 'Pendiente'
            },{
                link: '/account',
                icon: 'account-circle',
                name: 'Perfil'
            }
        ],
        workScheduleAllowed: true,
        admin: [
            {icon: 'view-dashboard', text: 'Inicio', link: 'home'},
            {icon: 'calculator', text: 'Cotizador', link: 'calculator'},
            {icon: 'history', text: 'Historial', link: 'account/history'},
            {icon: 'chart-box', text: 'Movimientos', link: 'account/movements'},
            {icon: 'account-group', text: 'Clientes', link: 'account/customers'},
            {icon: 'account-cash', text: 'Cajeros', link: 'account/staff'},
            {icon: 'store-marker', text: 'Sucursales', link: 'account/branch'},
            {icon: 'account-cash', text: 'Tasas de Cambio', link: 'account/rate'},
            {icon: 'account-cog', text: 'Ajustes', link: 'account/settings'},
            {icon: 'face-agent', text: 'Soporte', link: 'account/support'},
            {icon: 'account-question', text: 'Ayuda', link: 'account/help'}
        ],
        labels: {
            partner: 'Agente',
            value: 'Valor',
            currency: 'USD'
        },
        form: {
            partner: null,
            value: 0
        },
        currency_precision: 4
    }),
    mounted() {
        this.user = Object.assign(this.user, this.auth);
        this.timeout = setTimeout(this.getIni, 300000);
        this.getIni();
        this.update();
        this.checkWorkSchedule();
    },
    computed: mapGetters({
        auth: 'user',
    }),
    watch: {
        'user.role'() {
            if (this.user.role === 'Administrator') {
                this.$router.push({name: "AdminHome"});
            } else if (this.user.role === 'Customer') {
                this.$router.push({name: "Home"});
            } else {
                this.$emit('loader');
            }
        },
        'user.status'() {
            if (this.user.status === 202) {
                this.timeout = setTimeout(this.update, 60000);
            } else {
                clearTimeout(this.timeout);
            }
        }
    },
    methods: {
        getIni() {
            axios.get('/api/customer/notifications/count').then((res) => {
                this.count = res.data.notifications;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        hideLoader() {
            if (this.user.role === 'Customer') {
                this.$emit('loader');
            }
        },
        getSection(val) {
            this.section = val;
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        },
        update() {
            axios.get('/api/profile').then((res) => {
                this.user = res.data.user;
                this.$store.dispatch('setUser', res.data);
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        updatePartner(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/users/cashiers/' + id + '/update/partner', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.update();
                        this.$bvModal.hide('partner');
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        exit() {
            this.$swal({
                title: '¿Estas seguro que deseas cerrar sesión?',
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, Salir',
                confirmButtonColor: '#8bc34a',
                cancelButtonText: 'No, Esperar',
                cancelButtonColor: '#f44336',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.logout();
                }
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        async logout() {
            await this.$store.dispatch("logout");
            this.$root.$bvToast.toast('Has cerrado sesión correctamente.', {
                title: 'Felicitaciones',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            await this.$router.push({ name: "Login" });
        },
        checkWorkSchedule() {
            // Solo verificar si el usuario es Cashier, Partner o Supervisor
            if (!['Cashier', 'Partner', 'Supervisor'].includes(this.user.role)) {
                this.workScheduleAllowed = true;
                return;
            }
            
            axios.get('/api/partner/work-schedule/check').then((res) => {
                this.workScheduleAllowed = res.data.allowed;
            }).catch(err => {
                // En caso de error, permitir acceso por defecto para no bloquear la aplicación
                this.workScheduleAllowed = true;
            });
        }
    }
}
</script>
